import { addDoc, collection } from "firebase/firestore";
import { FirebaseService } from "../firebase.service";
import { QuizService } from "../quiz.interface";
import { Quiz } from "@/model/quiz.model";

export class QuizServiceBackend implements QuizService {
    private readonly QUIZZES = "QUIZZESS";
    private firebaseService;
    private firebaseDb;

    constructor (firebaseService: FirebaseService) {
        this.firebaseService = firebaseService;
        this.firebaseDb = this.firebaseService.getDb();
    }

    async saveQuiz(quiz: Quiz): Promise<void> {
        try {
            await addDoc(collection(this.firebaseDb, this.QUIZZES), {...quiz});
        } catch (error: any) {
            console.log(`Error creating new quiz. ${error}`);
        }
    }
}